import { extractImageFrames, clampTo } from '../../tools';
import type { KieModelConfig } from '../types';

export const viduConfigs: Record<string, KieModelConfig> = {
    'viduq4': {
        // https://kie.ai/vidu-q4?model=vidu-q4%2Fimage-to-video
        // https://kie.ai/vidu-q4?model=vidu-q4%2Freference-to-video
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, audioUri, audioUris, duration, aspectRatio, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            // 图生视频模式
            if (frameMode === 'first') {
                const [firstImage] = extractImageFrames(imagePrompt);
                return {
                    model: 'vidu-q4/image-to-video',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        duration: clampTo(duration || 5, [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16] as const, 5),
                        resolution: clampTo(quality || '720p', ['540p', '720p', '1080p', '2k', '4k'] as const, '720p'),
                        // 首帧 URL
                        image_url: firstImage!,
                        // 可选参数
                        audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                    },
                };
            }
            // 参考生视频模式
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 15);
            const audios = ((audioUris?.length ?? 0) > 0 ? audioUris! : audioUri ? [audioUri] : []).filter(Boolean).slice(0, 3);
            return {
                model: 'vidu-q4/reference-to-video',
                input: {
                    prompt: prompt.slice(0, 20000),
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '1:1', '4:3', '3:4'] as const, '16:9'),
                    duration: clampTo(duration || 5, [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16] as const, 5),
                    resolution: clampTo(quality || '720p', ['540p', '720p', '1080p', '2k', '4k'] as const, '720p'),
                    // 参考图 URL
                    reference_image_urls: images,
                    // 参考音频 URL
                    reference_audio_urls: audios,
                    // 可选参数
                    audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                },
            };
        },
    },
};
